import styled from 'styled-components';

const ErrorParagraph = styled.p`
  margin-top: 5px;
  color: #c14343;
`;

export default ErrorParagraph;
